export const selectors = {
  list: (state) => state.team.list,
  employees: (state) => state.team.employees,
  loadingListStatus: (state) => state.team.loadingListStatus,
  submitNewMemberStatus: (state) => state.team.submitNewMemberStatus,
  loadingMember: (state) => state.team.loadingMember,
  loadingEditedMember: (state) => state.team.loadingEditedMember,
  pagination: (state) => state.team.pagination,
  filters: (state) => state.team.filters,
};
